import { ROUTE_REGISTRY } from '@/lib/routes'

/**
 * Get the default dashboard route based on feature flags
 * When reporting feature flag is enabled, returns reporting route
 * Otherwise returns activity route
 *
 * This is used for:
 * - Default redirect after login
 * - Root /dashboard redirect
 * - Fallback redirects
 */
export function getDefaultDashboardRoute(isReportingEnabled: boolean): string {
  return isReportingEnabled
    ? ROUTE_REGISTRY.REPORTING.path
    : ROUTE_REGISTRY.ACTIVITY.path
}
